/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React, { useContext } from 'react';
import { ConfirmationDialog, BusyOverlay } from '@mummssoftware/common-ui';
import { HCPCSContext } from '../Context/contexts/HCPCSContext';
import { SubmitHCPCS } from './SubmitHCPCS';
import { HCPCSMenu } from './HCPCSMenu';
import { HCPCSSelection } from './HCPCSSelection';
import { LoadSavedHCPCS } from './LoadSavedHCPCS';
import defaults from '../../translations/en.json';

export const AddHCPCSDialog = () => {
  const { showHCPCS, showVisitLoader } = useContext(HCPCSContext);

  if (!showHCPCS) {
    return null;
  }

  return (
    <ConfirmationDialog
      title={defaults.recordHCPCS}
      disableBackdropClick
      fullWidth
      maxWidth="md"
      open={showHCPCS}
      handleClick={() => null}
      noIcon
      plusIcon={<HCPCSMenu />}
    >
      <BusyOverlay busy={!!showVisitLoader}>
        <LoadSavedHCPCS />
        <HCPCSSelection />
        <SubmitHCPCS />
      </BusyOverlay>
    </ConfirmationDialog>
  );
};
